import { Navigate, Outlet } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/stores/authContext';
import { ROUTES } from '@/routes/paths';

// Анти-guard для auth-экранов входа/регистрации/восстановления: залогиненного пользователя
// сразу уводим внутрь (нечего делать на странице входа). Экраны verify-email НЕ оборачиваются —
// они сами очищают сессию и должны отрабатывать токен из письма.
export default function AnonymousOnly() {
  const { isAuthenticated, isInitializing } = useAuth();

  // Ждём восстановления сессии, чтобы не мигать формой входа залогиненному пользователю.
  if (isInitializing) {
    return (
      <Center h="100dvh">
        <Loader />
      </Center>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.APP} replace />;
  }

  return <Outlet />;
}
